import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

/**
 * Atom that selects all sections from the questionnaire state.
 *
 * Note: This atom will trigger re-renders whenever ANY section changes.
 * For better performance when only accessing the current section,
 * prefer using `useCurrentSection()` which provides selective subscriptions.
 *
 * This atom is useful for components that need to read all sections
 * for navigation, progress indicators, or section lists.
 */
export const questionnaireSectionsAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.sections,
);
